import type { Field } from '@/api/types/crm/crm.types'

export type CrmLeadFieldRequiredContext = {
  funnelId?: number | null
  statusId?: number | null
}

/** Поле видно в воронке (по funnel_ids). Constant — всегда. */
export const isCrmLeadFieldVisibleInFunnel = (
  field: Pick<Field, 'is_constant' | 'funnel_ids'>,
  funnelId?: number | null,
): boolean => {
  if (field.is_constant === true) return true

  const rawFunnelId = Number(funnelId)
  if (!Number.isFinite(rawFunnelId) || rawFunnelId <= 0) return false

  const funnelIds = Array.isArray(field.funnel_ids) ? field.funnel_ids : []
  if (!funnelIds.length) return false

  return funnelIds.some((id) => Number(id) === rawFunnelId)
}

/**
 * Обязательность в карточке/создании лида по контексту сделки.
 * - Есть `required_scopes` → матч воронка + статусы (`[]` = вся воронка).
 * - Поле скрыто в воронке → не обязательное (даже если область есть).
 * - Глобальный `is_required` без scopes не используем для карточки.
 */
export const isCrmLeadFieldRequiredInContext = (
  field: Pick<
    Field,
    'is_active' | 'is_required' | 'required_scopes' | 'is_constant' | 'funnel_ids'
  >,
  context: CrmLeadFieldRequiredContext = {},
): boolean => {
  if (field.is_active === false) return false
  if (!isCrmLeadFieldVisibleInFunnel(field, context.funnelId)) return false

  const scopes = Array.isArray(field.required_scopes)
    ? field.required_scopes
    : []

  if (!scopes.length) {
    // Без областей глобальный is_required в карточке не применяем.
    return false
  }

  const funnelId = Number(context.funnelId)
  if (!Number.isFinite(funnelId) || funnelId <= 0) return false

  return scopes.some((scope) => {
    if (Number(scope.funnel_id) !== funnelId) return false

    const statusIds = Array.isArray(scope.status_ids) ? scope.status_ids : []
    // Пустой список = обязательность во всей воронке.
    if (statusIds.length === 0) return true

    const statusId = Number(context.statusId)
    if (!Number.isFinite(statusId) || statusId <= 0) return false

    return statusIds.some((id) => Number(id) === statusId)
  })
}
